import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import * as appStateActions from '../app-state/app-state.actions';
import * as ServiceLocatorActions from '../service-locator/service-locator.actions';
import { AppStateActionTypes } from './app-state.actions';

@Injectable()
export class AppStateEffects {
  constructor(private actions$: Actions) {}

  autocomplete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppStateActionTypes.SET_SEARCH_TYPE),
      map((action: appStateActions.SetSearchTypeAction) => action.payload),
      map(() => new ServiceLocatorActions.ServiceSearchByChanged()) // Clear the search results when the search type changes
    )
  );
}
